var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16.1437V4.99773C2 3.89973 2.886 3.00773 3.982 3.07473C4.959 3.13473 6.113 3.25373 7 3.48773C8.05 3.76373 9.296 4.35373 10.282 4.87573C10.8109 5.15413 11.4026 5.29155 12 5.27473V20.4747C11.4322 20.475 10.8731 20.3356 10.372 20.0687C9.372 19.5367 8.082 18.9187 7 18.6337C6.123 18.4017 4.984 18.2837 4.015 18.2227C2.906 18.1527 2 17.2557 2 16.1437Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.1437V4.93373C22 3.86073 21.154 2.98073 20.082 3.01773C18.953 3.05773 17.547 3.17373 16.5 3.48773C15.592 3.75873 14.535 4.30373 13.674 4.80273C13.1641 5.09726 12.5886 5.25952 12 5.27473V20.4747C12.56 20.4747 13.121 20.3387 13.628 20.0687C14.628 19.5367 15.918 18.9187 17 18.6337C17.877 18.4017 19.016 18.2837 19.985 18.2227C21.094 18.1527 22 17.2557 22 16.1437Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.2c781bef3fca45338b423d3ca3058ab4.svg";
export { ForwardRef as ReactComponent };